<template>
    <div v-if="loading" class="flex-center">
        <beat-loader :loading="loading" color="#C1006D"></beat-loader>
    </div>
</template>
<script>
    export default {
        name: 'ReaLoader',
        props: {
            loading: {
                type: Boolean,
                required: true,
                default: false,
            }
        }
    }
</script>
<style scoped>
.flex-center {
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(255,255,255, 0.8);
    z-index: 1001;
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    margin: 0;
}
</style>